import React from "react";

const ListenIcon = ({ width = 24, height = 24, color = "#242424" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 15.5V11.5C18 8.18629 15.3137 5.5 12 5.5C8.68629 5.5 6 8.18629 6 11.5V15.5M7.66667 17.5C6.74619 17.5 6 16.7538 6 15.8333V14.5C6 13.5795 6.74619 12.8333 7.66667 12.8333C8.58714 12.8333 9.33333 13.5795 9.33333 14.5V15.8333C9.33333 16.7538 8.58714 17.5 7.66667 17.5ZM16.3333 17.5C15.4129 17.5 14.6667 16.7538 14.6667 15.8333V14.5C14.6667 13.5795 15.4129 12.8333 16.3333 12.8333C17.2538 12.8333 18 13.5795 18 14.5V15.8333C18 16.7538 17.2538 17.5 16.3333 17.5Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ListenIcon;
